import Cookies from 'js-cookie'
import Vue from 'vue'
import VueI18n from 'vue-i18n'

// Locale JSONs live in the Vue 3 tree (shell inversion, phase 2.4) — all
// bundles load the same files.
import en from '../../../../zendrop-vue3/src/locales/en.json'

const localeLoaders = import.meta.glob('../../../../zendrop-vue3/src/locales/*.json')
const supportedLocales = Object.keys(localeLoaders).map((path) => path.match(/([\w-]+)\.json$/)[1])

function publishLocaleTerms(messages) {
  window.config = window.config || {}
  window.config.locales_terms = messages
}

export default {
  _instance: null,
  messages: { en },
  loadLocale (locale) {
    if (this.messages[locale]) {
      return Promise.resolve()
    }
    const loaderKey = Object.keys(localeLoaders).find((path) => path.endsWith(`/${locale}.json`))
    const loader = loaderKey && localeLoaders[loaderKey]
    if (!loader) {
      return Promise.resolve()
    }
    return loader().then((module) => {
      this.messages[locale] = module.default ?? module
      publishLocaleTerms(this.messages)
      if (this._instance) {
        this._instance.setLocaleMessage(locale, this.messages[locale])
      }
    })
  },
  install () {
    Vue.use(VueI18n)
    Vue.component('i18n').options.props = {
      ...Vue.component('i18n').options.props,
      displayHtmlTags: {
        type: Boolean,
        required: false,
        default: false,
      },
    }
    Vue.component('i18n').options.render = function (h, ref) {
      var data = ref.data
      var parent = ref.parent
      var props = ref.props
      var slots = ref.slots

      var $i18n = parent.$i18n
      if (!$i18n) {
        return
      }

      var path = props.path
      var locale = props.locale
      var params = slots()
      var children = $i18n.i(path, locale, params)

      var tag = (!!props.tag && props.tag !== true) || props.tag === false ? props.tag : 'span'

      if (props.displayHtmlTags) {
        let fn = (item) =>
          typeof item === 'string' ? h('span', { domProps: { innerHTML: item } }) : item

        children = Array.isArray(children) ? children.map(fn) : [children].map(fn)
      }

      return tag ? h(tag, data, children) : children
    }
  },
  getInstance () {
    if (!this._instance) {
      let fallbackLocale = 'en'
      let locale

      if (Cookies.get('zendrop-lang')) {
        locale = Cookies.get('zendrop-lang')
      } else if (document.documentElement.lang) {
        locale = document.documentElement.lang
      } else {
        locale = window.navigator.language.startsWith('pt') ? 'pt-BR' : fallbackLocale
      }

      // Accept only presented locales
      if (!supportedLocales.includes(locale)) {
        locale = fallbackLocale
      }

      const numberFormats = {
        'en': {
          currency: {
            style: 'currency',
            currency: 'USD',
          },
        },
        'pt-BR': {
          currency: {
            style: 'currency',
            currency: 'USD',
          },
        },
      }

      this._instance = new VueI18n({
        locale: locale,
        fallbackLocale: fallbackLocale,
        messages: this.messages,
        numberFormats: numberFormats,
      })

      publishLocaleTerms(this.messages)
      this.loadLocale(locale)
    }

    return this._instance
  },
}
